<template>
  <div class="row p-4">
    <div class="col-lg-12 col-xs-12">

      <h1>
        COLETA DE DADOS
      </h1>

      <div class="row">
        <div class="col-lg-12">
          <span class="ml-3 f14 font-weight-bold">NOME DO CAMPO</span>
          <inputform
            v-model="field_mapping_entity.parameters.name"
            type="text"
            :field="$v.field_mapping_entity.parameters.name"
            class="label-bold "
          />
        </div>

        <div class="col-lg-12">
          <span class="ml-3 f14 font-weight-bold">TIPO DO CAMPO</span>
          <select
            class="form-control"
            v-model="field_mapping_entity.parameters.type_field"
          >
            <option value="text">Texto</option>
            <option value="number">Número</option>
          </select>
        </div>

        <div class="col-lg-12 mt-3">
          <span class="ml-3 f14 mt-3 font-weight-bold">OBRIGATÓRIO</span>
          <select
            class="form-control"
            v-model="field_mapping_entity.parameters.required"
          >
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>

        <div class="col-lg-12 mt-3">
          <span class="ml-3 f14 mt-3 font-weight-bold">OCULTAR</span>
          <select
            class="form-control"
            v-model="field_mapping_entity.hidden"
          >
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>

        <div class="col-lg-12 mt-3">
          <span class="ml-3 f14 font-weight-bold">VALOR PADRÃO</span>
          <inputform
            v-model="field_mapping_entity.parameters.value_field"
            type="text"
            :field="$v.field_mapping_entity.parameters.value_field"
            class="label-bold "
          />
        </div>
        <div class="col-lg-6">

        </div>
        <div class="col-lg-6">
          <button
            :disabled="load"
            @click="save()"
            type="buttom"
            class="btn full btn-primary f13 p-2 radius-0"
          >
            SALVAR
          </button>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
export default {
  props: ["entity", "field_mapping"],
  mounted() {
    this.field_mapping_entity.entity = this.entity;
    console.log(this.field);
    if (this.field_mapping) {
      this.field_mapping_entity = this.field_mapping;
    }
  },
  data: () => ({
    load: false,
    field_mapping_entity: {
      id: 0,
      entity: "",
      hidden: false,
      parameters: {
        name: "",
        type_field: "text",
        required: false,
        value_field: "",
      },
    },
  }),
  computed: {
    entity_translate() {
      return {
        candidates: "Candidatos",
      };
    },
  },
  methods: {
    save() {
      this.load = true;
      this.$v.field_mapping_entity.$touch();

      if (this.$v.field_mapping_entity.$error) {
        this.$toast.error("PREENCHA CORRETAMENTE OS CAMPOS PARA CONTINUAR", {
          position: "top",
        });
        this.load = false;
        return false;
      }

      axios
        .post("/recruiters/field_mapping_entities", {
          field_mapping_entity: this.field_mapping_entity,
        })
        .then((response) => {
          this.$toast.success("Dados salvos com sucesso", {
            position: "top",
          });
          this.$emit("close");
        });
    },
  },
  validations: {
    field_mapping_entity: {
      parameters: {
        name: { required, minLength: minLength(2) },
        type_field: { required },
        value_field: {},
      },
    },
  },
};
</script>

<style>
</style>